// Toplupe主端重构版本
import { isInCoinsApp } from '@/utils/utils'
import { isMobile } from '@/utils/platform'
import { getAppVersion } from '@/utils/native.js'

export function getVersion() {
  // PC端订单页和关于页还是老版本
  if (!isMobile()) return 'version-1'
  if (isInCoinsApp()) {
    return getAppStyleVersion()
  }
  // 主端全量深色版
  return 'version-2'
}
// 客户端旧版本是浅色版，2.1.0 版之后都是深色版
export function getAppStyleVersion() {
  if (isLargerThanVersion()) {
    return 'version-2'
  } else {
    return 'version-2-2'
  }
}

export function isLargerThanVersion(baseV = '2.1.0', appVersion) {
  let targetV = appVersion
  if (!appVersion) {
    targetV = getAppVersion() // 返回 2.1.0 这种形式的版本号
  }
  const target = (targetV && targetV.split('.')) || []
  const baseArr = (baseV && baseV.split('.')) || []
  let flag = true
  for (let i = 0; i < target.length; i++) {
    if (target[i] < baseArr[i]) {
      flag = false
    }
    break
  }
  return flag
}
